import { MapElementFactory } from "vue2-google-maps";
let makeMarkerCall = 0
let marker = {};
export default MapElementFactory({
  name: "directionsRenderer",

  ctr() {
    return window.google.maps.DirectionsRenderer;
  },


  events: [],

  mappedProps: {},

  props: {
    origin: { type: Object },
    destination: { type: Object },
    travelMode: { type: String }
  },
  beforeCreate(options) {
    // return options.map 
  },

  afterCreate(directionsRenderer) {
  //  directionsRenderer.setMap(null);
    let directionsService = new window.google.maps.DirectionsService();

    this.$watch(
      () => [this.origin, this.destination, this.travelMode],
      () => {
        let { origin, destination, travelMode } = this;
        
        if (!origin || !destination || !travelMode) return;

        directionsService.route(
          {
            origin,
            destination,
            travelMode
          },

          (response, status) => {


             this.$root.mapMarker = response.routes.overview_path
            if (status !== "OK") return;

            function makeMarker(position, icon, title, map) {
                     marker = new window.google.maps.Marker({
                        position: position,
                        map: map,
                        icon: icon,
                        title: title
                    });
                     console.log("Marker", marker);
                    makeMarkerCall +=1

                    // window.google.maps.Marker.setPosition(position)

          }
            var icons = {
							start: new window.google.maps.MarkerImage(
								// URL
								"/img/location.png",
								// (width,height)
								new window.google.maps.Size(44, 32),
								// The origin point (x,y)
								new window.google.maps.Point(0, 0),
								// The anchor point (x,y)
								new window.google.maps.Point(22, 32)
							),
							end: new window.google.maps.MarkerImage(
								// URL
								"/img/delivery-man.png",
								// (width,height)
								new window.google.maps.Size(77, 77),
								// The origin point (x,y)
								new window.google.maps.Point(0, 0),
								// The anchor point (x,y)
								new window.google.maps.Point(22, 32)
							),
            };

            let map = directionsRenderer.getMap()

        //   new window.google.maps.DirectionsRenderer({
        //     map: map,
        //     directions: response,
        //     suppressMarkers: true
        // });

          var leg = response.routes[0].legs[0];
            if(makeMarkerCall == 0){
                makeMarker(leg.start_location, icons.start, "title", map);
                makeMarker(leg.end_location, icons.end, 'title', map);
            }else{
                marker.setPosition(leg.end_location);
                // window.google.maps.Marker.setPosition(leg.end_location);
                // vat latLong = new window.maps
                // alert(leg.end_location);
                // window.google.maps.Marker({
                //     position: (leg.end_location),
                //
                // });
                // window.google.maps.Marker.setPosition(leg.start_location)
            }
            directionsRenderer.setDirections( response, );
          }
        );
       
      }
    );
    
  }
});
